import React, { useState } from "react";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { NavigationContainer } from "@react-navigation/native";
import { Feather } from "@expo/vector-icons";
import { View, Animated } from "react-native";

import Inicio from "./pages/Inicio/Index";
import Login from "./pages/AreaCliente/Login/Index";
import Servicos from "./pages/Agendamento/Servicos/Servicos";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import Profissional from "./pages/Agendamento/Profissional/Profissional";

import Data from "./pages/Agendamento/Data/Data";
import Horarios from "./pages/Agendamento/Horarios/Horarios";
import Confirmacao from "./pages/Agendamento/Confirmacao/Confirmacao";
import DadosUsuario from "./pages/Agendamento/DadosUsuario/DadosUsuario";
import Comprovante from "./pages/Agendamento/Comprovante";
import { useTheme } from "../ThemeProvider";
import Menu from "./pages/AreaCliente/Menu/Index";
import Pacotes from "./pages/AreaCliente/Pacotes/Index";
import PacoteItens from "./pages/AreaCliente/Pacotes/Itens/Index";
import Historico from "./pages/AreaCliente/Historico/Index";
import Clientes from "./pages/AreaCliente/Clientes/Clientes";
import { DomainUtils } from "../Utils/domain";
import PagamentoOnline from "./pages/AreaCliente/PagamentoOnline/Index";
import ComprovantePtgOnline from "./pages/AreaCliente/PagamentoOnline/components/ComprovantePtgOnline";
import Assinaturas from "./pages/AreaCliente/Assinaturas";

const Tab = createBottomTabNavigator();
const Stack = createNativeStackNavigator();

// Componente personalizado para ícones do tab
const TabIcon = ({ name, focused, color, primaryColor, corFundoTab }: any) => {
  const scaleValue = React.useRef(new Animated.Value(1)).current;

  React.useEffect(() => {
    Animated.spring(scaleValue, {
      toValue: focused ? 1.2 : 1,
      useNativeDriver: true,
      tension: 100,
      friction: 8,
    }).start();
  }, [focused]);

  return (
    <View style={{ alignItems: "center", justifyContent: "center" }}>
      <Animated.View
        style={{
          transform: [{ scale: scaleValue }],
          padding: 8,
          borderRadius: 12,
        }}
      >
        <Feather
          name={name}
          size={focused ? 24 : 20}
          color={focused ? primaryColor : color}
        />
      </Animated.View>
    </View>
  );
};

export default function App() {
  const { primaryColor, configEmpresa } = useTheme();

  // Extrair cores da configuração da empresa
  const getConfigEmpresa =
    configEmpresa && typeof configEmpresa === "string"
      ? JSON.parse(configEmpresa)
      : {};
  const corFundoTab = getConfigEmpresa?.coresPWA?.corFundo || "#ffffff";
  const corFonteTab = getConfigEmpresa?.coresPWA?.corFontePrimaria || "#000000";
  const corInativaTab =
    getConfigEmpresa?.coresPWA?.corFonteSecundaria || "#8E8E93";
  const corBordaTab =
    getConfigEmpresa?.coresPWA?.corBordaPrimaria || "rgba(0,0,0,0.1)";

  const [tabKey, setTabKey] = useState(0);

  function InicioStack() {
    return (
      <Stack.Navigator
        screenOptions={{
          headerShown: false,
          title: DomainUtils.getNomePeloSubdomain(),
        }}
      >
        <Stack.Screen
          name="Servicos"
          component={Servicos}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="Profissional"
          component={Profissional}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="Data"
          component={Data}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="Horarios"
          component={Horarios}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="Confirmacao"
          component={Confirmacao}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="Comprovante"
          component={Comprovante}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="DadosUsuario"
          component={DadosUsuario}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="Menu"
          component={Menu}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="Pacotes"
          component={Pacotes}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="Historico"
          component={Historico}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="PacoteItens"
          component={PacoteItens}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="Clientes"
          component={Clientes}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="PagamentoOnline"
          component={PagamentoOnline}
          options={{ headerShown: false }}
        />

        <Stack.Screen
          name="Assinaturas"
          component={Assinaturas}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="ComprovantePtgOnline"
          component={ComprovantePtgOnline}
          options={{ headerShown: false }}
        />
      </Stack.Navigator>
    );
  }

  function handleInicioPress() {
    setTabKey(tabKey + 1);
    window.location.reload();
  }

  function TabNavigator() {
    return (
      <Tab.Navigator
        screenOptions={{
          headerShown: false,
          tabBarStyle: {
            backgroundColor: corFundoTab,
            elevation: 12,
            shadowColor: corFonteTab,
            shadowOffset: {
              width: 0,
              height: -4,
            },
            shadowOpacity: 0.15,
            shadowRadius: 8,
            height: 70,
            paddingBottom: 10,
            paddingTop: 10,
            borderTopLeftRadius: 25,
            borderTopRightRadius: 25,
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            borderTopWidth: 1,
            borderTopColor: corBordaTab,
          },
          tabBarActiveTintColor: primaryColor ?? "#007AFF",
          tabBarInactiveTintColor: corInativaTab,
          tabBarLabelStyle: {
            fontSize: 11,
            fontWeight: "700",
            marginTop: 10,
            letterSpacing: 0.5,
          },
          tabBarIconStyle: {
            marginBottom: 4,
          },
          tabBarItemStyle: {
            paddingVertical: 4,
          },
        }}
      >
        <Tab.Screen
          name="Início"
          key={tabKey}
          component={Inicio}
          options={{
            tabBarIcon: ({ color, focused }) => (
              <TabIcon
                name="home"
                focused={focused}
                color={color}
                primaryColor={primaryColor}
                corFundoTab={corFundoTab}
              />
            ),
            tabBarLabel: "Início",
          }}
          listeners={({ navigation }) => ({
            tabPress: () => {
              handleInicioPress();
            },
          })}
        />
        <Tab.Screen
          name="Login"
          component={Login}
          options={{
            tabBarIcon: ({ color, focused }) => (
              <TabIcon
                name="user"
                focused={focused}
                color={color}
                primaryColor={primaryColor}
                corFundoTab={corFundoTab}
              />
            ),
            tabBarLabel: "Área Cliente",
          }}
        />
        {/* Outras telas que devem aparecer na tab bar */}
      </Tab.Navigator>
    );
  }

  return (
    <NavigationContainer>
      <Stack.Navigator
        screenOptions={{
          headerShown: false,
          title: DomainUtils.getNomePeloSubdomain(),
        }}
      >
        <Stack.Screen
          name="TabNavigator"
          component={TabNavigator}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="InicioStack"
          component={InicioStack}
          options={{ headerShown: false }}
        />
      </Stack.Navigator>
    </NavigationContainer>
  );
}
